export function SidebarLeftComponent() {
  return {
    require: {
      parentCtrl: '^^scSidebar'
    },
    restrict: 'E',
    scope: false,
    template: require('./sidebar-left.component.html'),
  };
}



// WEBPACK FOOTER //
// ./src/layout/sidebar-left.component.js